export default {
  "content": "<path d=\"M5.5 7h-2v12h17V7h-2V5h3a1 1 0 011 1v14a1 1 0 01-1 1h-19a1 1 0 01-1-1V6a1 1 0 011-1h3v2z\" fill=\"#7B61FF\"/><path d=\"M17.322 3.57L13.91 8.5H17v2h-4v2h4v2h-4v3h-2v-3H7v-2h4v-2H7v-2h3.09L6.679 3.57l1.644-1.14L12 7.743l3.678-5.311 1.644 1.138z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};